var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "PHA-Part-A-Background.e92c3d4f.png",
    width: 1125,
    height: 2436
});